export default ['manuals'];
